import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from 'react-toastify';

const NetworkGuard = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleOffline = () => {
      setIsOnline(false);
      toast.error("No Internet Connection — Navigation disabled!");
      navigate(location.pathname, { replace: true }); // stay on same page
    };

    const handleOnline = () => {
      setIsOnline(true);
      toast.success("Internet Connection Restored!");
    };

    window.addEventListener("offline", handleOffline);
    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("offline", handleOffline);
      window.removeEventListener("online", handleOnline);
    };
  }, [navigate, location]);

  // BLOCK navigation clicks when offline
  useEffect(() => {
    if (!isOnline) {
      const preventClick = (e) => {
        const target = e.target.closest("a, button, [role='link'],[role='button']");
        if (target) {
          e.preventDefault();
          e.stopPropagation();
          toast.error("You are offline. Please reconnect to continue.");
        }
      };

      document.addEventListener("click", preventClick, true);
      return () => document.removeEventListener("click", preventClick, true);
    }
  }, [isOnline]);

  // Red banner when offline
  if (!isOnline) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          backgroundColor: "red",
          color: "white",
          textAlign: "center",
          padding: "8px",
          zIndex: 9999,
          fontWeight: "bold",
        }}
      >
        No Internet Connection — Navigation is disabled
      </div>
    );
  }

  return null;
};

export default NetworkGuard;
